/**
 * @file Submission read-only / review UI components — DatasetOverviewStagePlaceholder.tsx.
 */

import React from "react";
import "./DatasetOverviewStagePlaceholder.css";

/** Type definition — Dataset Overview Stage Placeholder Props. */
export type DatasetOverviewStagePlaceholderProps = {
  stageLabel: string;
};

const DatasetOverviewStagePlaceholder: React.FC<
  DatasetOverviewStagePlaceholderProps
> = ({ stageLabel }) => (
  <div className="dataset-overview-stage-placeholder">
    <div className="dataset-overview-stage-placeholder__title">
      {stageLabel} was not selected
    </div>
    <p className="dataset-overview-stage-placeholder__text">
      This lifecycle stage is not checked in Background Data, so no submitted
      values are expected for this section.
    </p>
  </div>
);

/** React component — Dataset Overview Stage Placeholder. */
export default DatasetOverviewStagePlaceholder;
